import React from 'react';
import * as API from 'modules/app/API'

class UserAvatar extends React.Component {
    render() {
        const style = this.props.small ? { width: 35, height: 35 } : this.props.style
        let avatarUrl = API.Security.url('/query/getAvatar?userId=' + this.props.userId);

        return (
            <img src={avatarUrl} className="img-circle c-user-card__avatar" role="presentation" alt="user avatar"
                style={style} />);
    }
}

export default UserAvatar;


// WEBPACK FOOTER //
// ./src/layouts/main/userAvatar/UserAvatar.js